import 'css-chunksrc/client/common/treeToggle/controls/closeAll/styles.scss';export default {
  "closeAll": "_closeAll_jcn1h_1",
  "disabled": "_disabled_jcn1h_10",
  "toggleArrow": "_toggleArrow_jcn1h_14"
};